import { globalMatrix } from "../../../globals";
import { IBaseControlOptions, BaseControl } from "./BaseControl";
import { ml } from "./../../matrixlib";
import { UIToolsConstants } from "../../matrixlib/MatrixLibInterfaces";
import { FieldHandlerFactory } from "../../businesslogic";
import { FieldDescriptions } from "../../businesslogic/FieldDescriptions";
import { HyperlinkFieldHandler } from "../../businesslogic/FieldHandlers/HyperlinkFieldHandler";
import { ControlState } from "../../../types";

export type { IHyperlinkOptions };
export { HyperlinkImpl };

interface IHyperlinkOptions extends IBaseControlOptions {
    controlState?: ControlState;
    canEdit?: boolean;
    help?: string;
    fieldValue?: string;
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    valueChanged?: Function;
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    parameter?: {};
    fieldValueLabel?: string; // displayed name of hyperlink (by default uses last part of url)
    linkPrefix?: string; // if set, is displayed before name of hyperlink
}

// TODO: MATRIX-7555: lint errors should be fixed for next line
// eslint-disable-next-line
$.fn.hyperlink = function (this: JQuery, options: IHyperlinkOptions) {
    if (!options.fieldHandler) {
        options.fieldHandler = FieldHandlerFactory.CreateHandler(
            globalMatrix.ItemConfig,
            FieldDescriptions.Field_hyperlink,
            options,
        );
        options.fieldHandler.initData(options.fieldValue);
    }
    let baseControl = new HyperlinkImpl(this, options.fieldHandler as HyperlinkFieldHandler);
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    this.getController = () => {
        return baseControl;
    };
    baseControl.init(options);
    return this;
};

class HyperlinkImpl extends BaseControl<HyperlinkFieldHandler> {
    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
    private settings: IHyperlinkOptions;
    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
    private lastValueChanged: number;
    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
    private _editor: JQuery;

    constructor(control: JQuery, fieldHandler: HyperlinkFieldHandler) {
        super(control, fieldHandler);
    }

    private getHandler(): HyperlinkFieldHandler {
        return <HyperlinkFieldHandler>this.settings.fieldHandler;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    init(options: IHyperlinkOptions) {
        let that = this;
        let defaultOptions = {
            controlState: ControlState.FormView, // read only rendering
            canEdit: false, // whether data can be edited
            dummyData: false, // fill control with a dumy text (for form design...)
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            valueChanged: function () {}, // callback to call if value changes
            parameter: {
                placeholder: "www.google.com", // can be a dummy text, e.g. for creation dialog
                readonly: false, // can be set to overwrite the default readonly status
            },
        };
        this.settings = ml.JSON.mergeOptions(defaultOptions, options);

        if (typeof this.settings.fieldValue === "undefined" || this.settings.fieldValue === "") {
            this.settings.fieldValue = "";
        }

        if (this.settings.controlState === ControlState.Print) {
            this._root.append(super.createHelp(this.settings));
            this._root.append("<div class='printBox'>" + this.settings.fieldValue + "</div>");
            return;
        }
        if (this.settings.controlState === ControlState.Tooltip) {
            this._root.append("<p>" + this.settings.fieldValue + "</p>");
            return;
        }
        this._root.append(super.createHelp(this.settings));
        let ctrlContainer = $("<div>").addClass("baseControl");
        this._root.append(ctrlContainer);

        let hyper = $("<span>").appendTo(ctrlContainer);

        this._root.data("original", this.settings.fieldValue);
        this._root.data("new", this.settings.fieldValue);

        this.showLink(hyper);

        if (this.settings.canEdit) {
            let edit = this.settings.fieldValue ? "edit" : "add link";
            $("<button class='btn btn-link'>(" + edit + ")</button>")
                .appendTo(ctrlContainer)
                .click(function () {
                    let dlg = $("<div>").appendTo($("body"));

                    let textInput = $("<div>");
                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                    // eslint-disable-next-line
                    let textContainer: any = { url: that.settings.fieldValue ? that.settings.fieldValue : "" };
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    ml.UI.addTextInput(textInput, "URL:", textContainer, "url", null);

                    ml.UI.showDialog(
                        dlg,
                        "Edit URL",
                        textInput,
                        -730,
                        -340,
                        [
                            {
                                text: "Apply",
                                class: "btnDoIt",
                                // TODO: MATRIX-7555: lint errors should be fixed for next line
                                // eslint-disable-next-line
                                click: function () {
                                    that._root.data("new", textContainer["url"]);
                                    if (that.settings.valueChanged) {
                                        that.settings.valueChanged();
                                    }
                                    that.showLink(hyper);
                                    dlg.dialog("close");
                                },
                            },
                            {
                                text: "Cancel",
                                class: "btnCancelIt",
                                // TODO: MATRIX-7555: lint errors should be fixed for next line
                                // eslint-disable-next-line
                                click: function () {
                                    dlg.dialog("close");
                                },
                            },
                        ],
                        UIToolsConstants.Scroll.None,
                        false,
                        false,
                        () => {
                            dlg.remove();
                        },
                        () => {},
                        () => {},
                    );
                });
        }
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected showLink(container: JQuery) {
        let url: string = this._root.data("new") ? this._root.data("new") : "";
        let full = url;
        let title = url;

        let qm = url.indexOf("?");

        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        if (qm != -1) {
            title = url.substr(qm + 1);
            url = url.substr(0, qm);
        }
        // fix for MATRIX-4354 : URL fields in Matrix: no way to enter them anymore
        // let's undo what the  HTML cleanup is doing for &
        full = full.replace("&lt;", "%3C").replace("&amp;", "&");
        container.html("");
        let hyper = $("<span>").appendTo(container);
        hyper.html(this.settings.linkPrefix ? this.settings.linkPrefix : "").append(
            $('<a title="' + title + '">' + url + "</a>")
                .attr("href", full)
                .attr("target", "_blank"),
        );
    }

    // public interface
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    async hasChangedAsync() {
        // make sure no changes are pending
        clearTimeout(this.lastValueChanged);
        // this will take and text from the editor and put it int he variable  _root.data("new")
        // but it will not recursively trigger a change
        this.valueChanged(true);
        // now compare
        return this._root.data("original") !== this._root.data("new");
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    async getValueAsync() {
        // make sure no changes are pending
        clearTimeout(this.lastValueChanged);
        this.valueChanged(true);
        return this._root.data("new");
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    destroy() {
        if (this._editor) {
            this._editor.off();
        }
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    resizeItem() {}
    // private functions
    private valueChanged(noCallback: boolean): void {
        if (this._editor && this.settings.canEdit) {
            this._root.data("new", this._editor.val());
        }
        if (this.settings.valueChanged && !noCallback) {
            this.settings.valueChanged.apply(null);
        }
    }
}
